import type { NextPage } from 'next'
import { Jobs } from '@/client/modules/Jobs'
import { JobsProps } from '@/client/modules/Jobs/types'
import { getCMSContent } from '@/client/utils'

const JobsPage: NextPage<JobsProps> = (data) => <Jobs {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'JOBS')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default JobsPage
